"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pureJs_1 = require("./pureJs");
var whatwgEncodingApi_1 = require("./whatwgEncodingApi");
function fromUtf8(input) {
  if (typeof TextEncoder === "function") {
    return whatwgEncodingApi_1.fromUtf8(input);
  }
  return pureJs_1.fromUtf8(input);
}
exports.fromUtf8 = fromUtf8;
function toUtf8(input) {
  if (typeof TextDecoder === "function") {
    return whatwgEncodingApi_1.toUtf8(input);
  }
  return pureJs_1.toUtf8(input);
}
exports.toUtf8 = toUtf8;